import { useRef } from "react";
import { useForm } from "@inertiajs/react";
import Tiptap from "@/components/TipTap/TipTap";
import Button from "@/components/buttons/Button";
import Input from "@/components/inputs/Input";
import InertiaLink from "@/components/buttons/InertiaLink";
import PageHeader from "@/components/PageHeader";
import FormActions from "@/components/buttons/FormActions";

export interface Brief {
  id: number;
  title: string;
  body: any;
}

const Edit: React.FC<{ brief: Brief }> = ({ brief }) => {
  const editorRef = useRef<any>(null); // Reference to the editor instance

  const { data, setData, put, processing, errors } = useForm({
    title: brief.title,
    body: brief.body,
  });

  const handleEditorContentChange = (content: any) => {
    setData("body", content);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    put(`/briefs/${brief.id}`);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
        <div className="flex w-full flex-col gap-5">
          <PageHeader
            backLink={{ href: `/briefs/${brief.id}`, text: "Back to brief" }}
            title={brief.title}
            secondaryAction={{ href: `/briefs/${brief.id}`, text: "Cancel" }}
          />
          <div className="flex w-full flex-row items-baseline justify-between gap-5">
            <div className="flex w-full flex-col gap-2">
              <Input
                type="text"
                value={data.title}
                onChange={(e) => setData("title", e.target.value)}
                placeholder="Brief title"
                errors={errors.title}
                label="Title"
              />
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col">
          <Tiptap
            content={data.body}
            setEditorContent={handleEditorContentChange}
            onEditorReady={(editor) => (editorRef.current = editor)}
            initialiseAsEditable={true}
          />
        </div>
        <FormActions>
          <InertiaLink
            href={`/briefs/${brief.id}`}
            type="secondary"
            text="Cancel"
          />
          <Button type="primary" text="Save" disabled={processing} />
        </FormActions>
      </div>
    </form>
  );
};

export default Edit;
